// Import necessary libraries and styles
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/second.css';  // Custom CSS for hover effect
import image1 from '../images/appstore.jpg';
import image2 from '../images/gre.png';
import image3 from '../images/iitkgp.png';
import image4 from '../images/cuk.png';

const Second = () => {
  const images = [image1, image2, image3, image4];

  const programs = [
    { title: 'App Store Developer License ', Rank: ' Android & IOS', description: ' 2024' },
    { title: 'GRE-2022', Rank:' 322/340 - 94.7 %', description: ' 22-Aug-2022' },
    { title: 'IIT-Kharagpur', Rank:' All India Rank - 203', description: ' 2019' },
    { title: 'CUCET - 2014 ', Rank:' All India Rank - 31', description: '2014 ' },
  ];

  return (
    <div className="container py-5">
      <h2 className="text-start text-dark fw-bold mb-5">Achievements/Awards</h2>
      <hr/>
      <div className="row">
        {programs.map((program, index) => (
          <div key={index} className="col-lg-3 col-md-6 col-6 mb-4">
            <div className="program-card p-4 text-center h-100">
              <img
                src={images[index % images.length]}
                className="card-img-top img-fluid"
                alt="logos"
                style={{ width: '100px', height: '100px', objectFit: 'contain', margin: '0 auto' }}
              />
              <h3 className="program-title mb-3">{program.title}</h3>
              <h5 className="mb-3 text-primary">{program.Rank}</h5>
              <p className="program-description fw-bold text-black">{program.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Second;
